import {CashPointEntryBase} from "./cash-point-entry-base";
import {DeviceNl} from "./device-nl";
import {ClosingModel} from "./closing-model";
import {BusinessCaseType} from "./_enums/business-case-type";

export class CashPointEntryDto extends CashPointEntryBase {
  device: DeviceNl = new DeviceNl();
  closingNumber: number | undefined;

  /**
   * How the till was opened (#836): Anfangsbestand or Geldtransit (Einlage). Null/absent for an entry opened
   * before #836.
   */
  openingType?: BusinessCaseType | null;

  /** The cash the till was opened with (#836), whichever type it was booked as. Null/absent before #836. */
  openingAmount?: number | null;

  // just for closing assistant
  closing: ClosingModel = new ClosingModel();

  static init(cpe: CashPointEntryDto) {
    cpe.closing = new ClosingModel();
  }

  /**
   * The cash the till was opened with (#836): the amount stored at opening, or for an entry opened before #836 its
   * Anfangsbestand total. A till opened with a Geldtransit has no Anfangsbestand at all, so that total alone reads
   * 0 there whether the drawer started empty or held 87,50 €.
   *
   * @returns undefined when neither is known.
   */
  static openingFloat(cpe: CashPointEntryDto, businessCaseTypes: { [p: number]: number }): number | undefined {
    if (cpe.openingAmount !== undefined && cpe.openingAmount !== null) return cpe.openingAmount;
    return businessCaseTypes[BusinessCaseType.Anfangsbestand];
  }

  /**
   * The „Endbestand" the close screens propose (#836), which is not the opening float on every till: a Geldtransit
   * opening means the previous closing emptied the drawer (DSFinV-K 2.4 Anhang C p. 56), so such a till closes
   * back to 0,00 €. An Anfangsbestand opening keeps its float, and an entry that stored no type — one opened
   * before #836 — falls back to its Anfangsbestand total.
   *
   * The stored type decides, never the figures: a Geldtransit-opened entry can carry an Anfangsbestand total too,
   * from a „Vorgang buchen → Anfangsbestand" correction booked later in the period. The register applies the same
   * rule in `SkimmingTargetSuggestion`, and the two screens must propose the same money.
   *
   * @returns undefined when nothing is known, so the caller keeps whatever it had.
   */
  static skimTarget(cpe: CashPointEntryDto, businessCaseTypes: { [p: number]: number }): number | undefined {
    if (cpe.openingType === BusinessCaseType.Geldtransit) return 0;
    return CashPointEntryDto.openingFloat(cpe, businessCaseTypes);
  }
}
